"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _flagsInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flags");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConnectedStandardAppBar = exports.mapDispatchToProps = exports.getLoocalizedStrings = exports.mapStateToProps = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _StandardAppBar = require("@uifabric/portal-ux/lib/StandardAppBar");

var _reactRedux = require("react-redux");

var _featureFlags = require("../../feature-flags");

var _models = require("../../FeatureFlags/models");

var _Nav = require("../../Nav/models/Nav");

var _isDialogOpen = require("../../Notifications/isDialogOpen");

var _models2 = require("../../Notifications/models");

var _models3 = require("../../Options/models");

var _createAction = require("../../redux/createAction");

var _SearchActions = require("../../Search/models/SearchActions");

var _getUserImageUrl = require("../../User/getUserImageUrl");

var _models4 = require("../../User/models");

/**
 * Maps the external (i.e. own) props and the state to the properties of the StandardAppBar control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IStandardAppBarProps) for the StandardAppBar control
 */
var mapStateToProps = function mapStateToProps(state, props) {
  var _props$t;

  var user = state.user !== undefined ? state.user : undefined;

  if (user === undefined) {
    return props;
  }

  var featureFlags = _flagsInstanceProperty(_featureFlags).get();

  var showFlags = featureFlags.showFlags || process.env.NODE_ENV === 'development';
  var primaryOrg = undefined;

  if (state.user.organizationsById !== undefined && state.user.currentOrg !== undefined) {
    primaryOrg = state.user.currentOrg;
  }

  var appStateKey = props.appStateKey;
  var searchContext = appStateKey && state[appStateKey] !== undefined ? state[appStateKey].searchContext : 'unknown';
  return (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, state.nav), state.search), getLoocalizedStrings(props.t)), {}, {
    myAvatarUrl: (0, _getUserImageUrl.getUserImageUrl)(state.user.userImage),
    isTenantPickerOpen: (0, _isDialogOpen.isDialogOpen)(state, _models4.UserActions.showTenantPicker),
    isNotificationPanelOpen: (0, _isDialogOpen.isDialogOpen)(state, _models2.NotificationsActions.showCardNotificationPanel),
    tenantName: primaryOrg ? primaryOrg.displayName : '',
    helpVisible: process.env.APP_HIDE_HELP !== 'true',
    optionsVisible: process.env.APP_ENABLE_OPTIONS === 'true' && featureFlags.showOptions === true,
    isOptionsOpen: (0, _isDialogOpen.isDialogOpen)(state, _models3.OptionsActions.showOptions),
    isMeControlOpen: (0, _isDialogOpen.isDialogOpen)(state, _models4.UserActions.showMe),
    isHelpOpen: (0, _isDialogOpen.isDialogOpen)(state, _models3.OptionsActions.showHelp),
    notificationsVisible: process.env.APP_ENABLE_NOTIFICATIONS === 'true',
    searchTerm: state.search.searchTerm || '',
    searchContext: searchContext,
    enableExtendedSearch: !featureFlags.disableExtendedSearch,
    showFiltersIcon: featureFlags.appBarSearchFilters,
    isFlagsOpen: (0, _isDialogOpen.isDialogOpen)(state, _models.FeatureFlagsActions.showFeatureFlags),
    flagsVisible: showFlags,
    flagsLabel: 'Flags'
  }, props), {}, {
    searchVisible: searchContext ? props.searchVisible : false,
    searchPlaceholderText: props.searchPlaceholderText !== undefined ? props.searchPlaceholderText : (_props$t = props.t) === null || _props$t === void 0 ? void 0 : _props$t.call(props, 'Search')
  });
};

exports.mapStateToProps = mapStateToProps;

var getLoocalizedStrings = function getLoocalizedStrings(t) {
  if (t === undefined) {
    return {};
  }

  return {
    waffleLabel: t('Apps'),
    notificationsLabel: t('Notifications'),
    optionsLabel: t('Settings'),
    helpLabel: t('Help'),
    meControlLabel: t('My account'),
    showSearchButtonLabel: t('Search'),
    navButtonLabel: t('Open navigation menu'),
    backButtonLabel: t('Go back'),
    tenantPickerLabel: t('Switch organizations'),
    removePersonaButtonAriaLabel: t('Remove'),
    executeSearchLabel: t('Execute search')
  };
};

exports.getLoocalizedStrings = getLoocalizedStrings;
var searchId = 1;
/**
 * Maps the dispatch actions to the props for the StandardAppBar control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IStandardAppBarProps) for the StandardAppBar control
 */

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var searchAction = function searchAction(searchContext, searchTerm) {
    searchId++;
    (0, _createAction.createAction)(_SearchActions.SearchActions.searchChanged, dispatch, {
      traceId: searchId
    })(searchTerm);

    if (_flagsInstanceProperty(_featureFlags).get().disableAppBarPersonaSearch && searchContext) {
      (0, _createAction.createAction)(searchContext, dispatch, {
        traceId: searchId
      })(searchTerm);
    }
  };

  var executeSearch = (0, _createAction.createAction)(_SearchActions.SearchActions.executeSearch, dispatch);
  var searchClear = (0, _createAction.createAction)(_SearchActions.SearchActions.clearSearch, dispatch);
  return {
    onToggleMenu: (0, _createAction.createAction)(_Nav.NavActions.expandNav, dispatch),
    collapseNav: (0, _createAction.createAction)(_Nav.NavActions.collapseNav, dispatch),
    onOptionsClick: (0, _createAction.createAction)(_models3.OptionsActions.showOptions, dispatch),
    onHelpClick: (0, _createAction.createAction)(_models3.OptionsActions.showHelp, dispatch),
    onMeClick: (0, _createAction.createAction)(_models4.UserActions.showMe, dispatch),
    goBack: function goBack(searchContext) {
      searchClear();
    },
    onSearchChange: searchAction,
    onSearch: function onSearch(searchContext, searchTerm, actionSource, pills) {
      executeSearch({
        searchContext: searchContext,
        searchTerm: searchTerm,
        actionSource: actionSource,
        pills: pills
      });

      if (searchContext && searchContext !== 'unknown') {
        (0, _createAction.createAction)(searchContext, dispatch)(searchTerm);
      }
    },
    addPersona: (0, _createAction.createAction)(_SearchActions.SearchActions.addPersona, dispatch),
    removePersona: (0, _createAction.createAction)(_SearchActions.SearchActions.removePersona, dispatch),
    onFilterClick: (0, _createAction.createAction)(_SearchActions.SearchActions.showFilter, dispatch),
    toggleSaveSearch: (0, _createAction.createAction)(_SearchActions.SearchActions.toggleSaveSearch, dispatch),
    setSelectedSuggestionIndex: (0, _createAction.createAction)(_SearchActions.SearchActions.setSelectedSuggestionIndex, dispatch),
    setSearchTextForSuggestion: (0, _createAction.createAction)(_SearchActions.SearchActions.setSearchTextForSuggestion, dispatch),
    selectSuggestionByIndex: (0, _createAction.createAction)(_SearchActions.SearchActions.selectSuggestionByIndex, dispatch),
    addKeywordSuggestion: (0, _createAction.createAction)(_SearchActions.SearchActions.addKeywordSuggestion, dispatch),
    selectFilterItem: (0, _createAction.createAction)(_SearchActions.SearchActions.selectFilterKey, dispatch),
    hideFilter: (0, _createAction.createAction)(_SearchActions.SearchActions.hideFilter, dispatch),
    onFlagsClick: (0, _createAction.createAction)(_models.FeatureFlagsActions.showFeatureFlags, dispatch),
    onTenantPickerClick: (0, _createAction.createAction)(_models4.UserActions.showTenantPicker, dispatch),
    onNotificationPanelClick: (0, _createAction.createAction)(_models2.NotificationsActions.showCardNotificationPanel, dispatch)
  };
};
/**
 * A redux connected StandardAppBar control.
 */


exports.mapDispatchToProps = mapDispatchToProps;
var ConnectedStandardAppBar = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_StandardAppBar.StandardAppBar);
exports.ConnectedStandardAppBar = ConnectedStandardAppBar;